export default __webpack_public_path__ + "static/media/Mobile_Scroll-3.42c8865a.jpg";